export const STATUS_LABELS = {
  DEMANDE_INITIEE: "Demande initiée",
  REDIRECTION_PARTENAIRE: "Redirigé vers la plateforme",
  RECHERCHE_MEDICALE_EN_COURS: "Recherche médicale",
  RENDEZ_VOUS_MEDICAL_SELECTIONNE: "RDV médical sélectionné",
  RECHERCHE_CABINE: "Recherche cabine",
  CABINE_EN_ATTENTE: "Cabine en attente",
  CABINE_RESERVEE: "Cabine réservée",
  RENDEZ_VOUS_CONFIRME: "RDV confirmé",
  AUCUNE_DISPONIBILITE_MEDICALE: "Aucune dispo médicale",
  AUCUNE_CABINE_COMPATIBLE: "Aucune cabine compatible",
  PATIENT_ARRIVE: "Patient arrivé",
  TELECONSULTATION_TERMINEE: "Terminée",
  ANNULE: "Annulé",
  EXPIRE: "Expiré",
};

export const STATUS_STYLES = {
  DEMANDE_INITIEE: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  REDIRECTION_PARTENAIRE: "bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-300",
  RECHERCHE_MEDICALE_EN_COURS: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300",
  RENDEZ_VOUS_MEDICAL_SELECTIONNE: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300",
  RECHERCHE_CABINE: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  CABINE_EN_ATTENTE: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  CABINE_RESERVEE: "bg-indigo-100 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300",
  RENDEZ_VOUS_CONFIRME: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  AUCUNE_DISPONIBILITE_MEDICALE: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300",
  AUCUNE_CABINE_COMPATIBLE: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300",
  PATIENT_ARRIVE: "bg-emerald-600 text-white",
  TELECONSULTATION_TERMINEE: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  ANNULE: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300",
  EXPIRE: "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
};

export const statusLabel = (s) => STATUS_LABELS[s] || s;
export const statusStyle = (s) => STATUS_STYLES[s] || STATUS_STYLES.DEMANDE_INITIEE;
